export const dateFormat = {
  DATE: 'MM-DD-YYYY',
  TIME: 'h:mm A',
  TIME24: 'HH:mm',
  DAY: 'ddd',
  SHORT_DATE_TIME: 'M/D h:mm A',
  DATE_TIME: 'MM-DD-YYYY h:mm A',
  DATE_TIME_SLASHES: 'MM/DD/YYYY, h:mm A',
  MONTH_DATE_TIME: 'MMM D, h:mm A',
  MONTH_DATE_YEAR: 'MMM D YYYY',
  MONTH_DATE_YEAR_TIME: 'MMM D YYYY h:mm A',
  YEAR_MONTH_DATE: 'YYYY-MM-DD',
  DAY_TIME: 'ddd D, h:mm A',
  WEEKDAY_MONTH_DATE: 'ddd M/D',
  WEEKDAY_MONTH_DATE_TIME: 'ddd M/D h:mm A',
  ISO: 'YYYY-MM-DDTHH:mm:ss',
  DATE_ZERO_TIME: 'YYYY-MM-DDT00:00:00',
  DATE_SLASHES: 'MM/DD/YYYY',
}
